import React, { useRef, useState } from "react";
import { useGLTF,Html } from "@react-three/drei";





export default function Xpad(props)
{
    // const { nodes, materials } = useGLTF("./models/CompleteStation.glb");
    const pad = useGLTF("./imagePad.glb");
    

  return (
    


    <primitive {...props} object={pad.scene}   >
      
     

    </primitive>
    




    
   
  );
}

